import { useMemo } from 'react';
import type { SeriesInstanceUid } from '~/domain/dicom/uids';
import { getDatasetEnvironmentRegistry } from '~/engine/scene/datasetEnvironmentRegistryInstance';
import { useSubscriptionVersion } from './useSubscriptionVersion';

/**
 * Re-renders on every fusion write (fuse, clear, moved blend) for a series,
 * which changes what its row draws. Follows nothing while it is undefined.
 */
export function useFusionVersion(
    seriesUid: SeriesInstanceUid | undefined
): void {
    useSubscriptionVersion(
        useMemo(
            () =>
                seriesUid === undefined
                    ? undefined
                    : (listener: () => void) =>
                          getDatasetEnvironmentRegistry().subscribeFusion(
                              seriesUid,
                              listener
                          ),
            [seriesUid]
        )
    );
}
